export const validateGroupResults = ({ step, status }) => {
  if (!step?.arguments?.inputStepIds || step?.arguments?.inputStepIds?.length === 0) {
    return { status, id: 'go-to-config', message: 'Add data sources to group' };
  }

  return { status: 'valid' };
};
